
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns3b426d226871dd1fdf202d38b87217c9en from './en.yaml'
            i18n.addResourceBundle('en', '3b426d226871dd1fdf202d38b87217c9', flattenObject(ns3b426d226871dd1fdf202d38b87217c9en), true, true);
        
        export default '3b426d226871dd1fdf202d38b87217c9';
    